export default __webpack_public_path__ + "gt_ws.png";